module.exports = __webpack_public_path__ + "img/swapface.f5938964.jpg";